import { Component, signal } from '@angular/core';
import { AppShellComponent } from './components/shell/shell.component';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { RussianPaginatorIntl } from './utils/russian-paginator-intl';

@Component({
    selector: 'app-root',
    imports: [AppShellComponent],
    templateUrl: './app.html',
    styleUrl: './app.css',
    providers: [ { provide: MatPaginatorIntl, useClass: RussianPaginatorIntl } ],
})
export class AppComponent {
    protected readonly title = signal('sns-prototype');
}
